const shiftMobileUGC = function(){
  let mobileUGC = document.querySelector('.user-generated-content[data-stand-in="false"]');
  let desktopContainer = document.querySelector('.main-product[data-quick-view="false"]');
  let mobileContainer = document.querySelector('.main-product[data-quick-view="false"] .main-content__mobile-ugc-container');
  if(window.innerWidth >= 900){
    if(mobileUGC && mobileUGC.closest('.main-content__mobile-ugc-container') && mobileUGC.getAttribute('data-position') != "desktop"){
      mobileUGC.setAttribute('data-position', 'desktop')
      var fragment = document.createDocumentFragment();
      fragment.appendChild(mobileUGC);
      desktopContainer.appendChild(fragment)
    }
  } else {
    if(mobileUGC && !mobileUGC.closest('.main-content__mobile-ugc-container') && mobileUGC.getAttribute('data-position') != "mobile"){
      mobileUGC.setAttribute('data-position', 'mobile')
      var fragment = document.createDocumentFragment();
      fragment.appendChild(mobileUGC);
      mobileContainer.appendChild(fragment)
    }
  }
}

const updatePaginationPosition = function(index){
  let container = document.querySelector('.user-generated-content[data-stand-in="false"] .user-generated-content__pagination')
  let containersWidth = container.offsetWidth;
  let itemsCount = parseInt(container.getAttribute('data-items-count'));
  let tilesWidth = (itemsCount * 50) + ((itemsCount - 1) * 4);
  let bullets = container.querySelectorAll('.swiper-pagination-bullet');


  if(window.innerWidth >= 900){
    if(containersWidth < tilesWidth){
      let difference = tilesWidth - containersWidth;
      let percentageAcross = index == 0 ? 0 : index / (itemsCount - 1);
      if(bullets.length > 0){
        bullets.forEach((bullet) => {
          bullet.style.transform = `translateX(-${difference * percentageAcross}px)`
        })
      }
    } 
  }
}

const updateVisibleHandle = function(index){
  let allHandles = document.querySelectorAll('.user-generated-content[data-stand-in="false"] .user-generated-content__user-handle');
  if(allHandles.length > 0){
    if(window.innerWidth >= 900){
      allHandles.forEach((handle) => {
        handle.setAttribute('data-visible', false)
      });
      setTimeout(() => {
        allHandles[index].setAttribute('data-visible', true);
      }, 250)
    }
  }
}

const initUserGeneratedSwiper = function(){
    // Swiper is loaded lazily on product pages (see _head_scripts.liquid). Wait until it's ready.
    if (typeof window.Swiper === 'undefined') {
      if (typeof window.whenSwiperReady === 'function') {
        window.whenSwiperReady(initUserGeneratedSwiper);
      }
      return;
    }

    let thumbnailImages = [];
    let images = document.querySelectorAll('.user-generated-content[data-stand-in="false"] .user-generated-content__gallery-outer-container .user-generated-content__user-image img');
    images.forEach((image) => {
      thumbnailImages.push(`${image.getAttribute('srcset')}`)
    })
    let params = {
      slidesPerView: 1.33333,
      spaceBetween: 10,
      navigation: {
          nextEl: ".user-generated-content .swiper-button-next",
          prevEl: ".user-generated-content .swiper-button-prev",
      },
      breakpoints: {
          600: {
            slidesPerView: 2.5,
            spaceBetween: 10,
            navigation: {
              nextEl: ".user-generated-content .swiper-button-next",
              prevEl: ".user-generated-content .swiper-button-prev",
            }
          },
          900: {
            slidesPerView: 1,
            spaceBetween: 48,
            navigation: {
              nextEl: ".user-generated-content .swiper-button-next",
              prevEl: ".user-generated-content .swiper-button-prev",
            },
            pagination: {
              el: ".user-generated-content__pagination.swiper-pagination",
              clickable: true,
              renderBullet: function (index, className) {
                return `<span class=${className} ><img srcset="${thumbnailImages[index]}"/></span>`
              },
            },
          }
        },
        on: {
          slideChange: function () {
            updatePaginationPosition(this.realIndex);
            updateVisibleHandle(this.realIndex);
          },
          init: function () {
            updatePaginationPosition(0);
            updateVisibleHandle(0)
          },
        },
    }

    let slidesPerView = 4;
    if(document.querySelectorAll('.user-generated-content__thumbnail-gallery-inner-container .user-generated-content__thumbnail-user-wrapper').length > 0){
      slidesPerView = document.querySelectorAll('.user-generated-content__thumbnail-gallery-inner-container .user-generated-content__thumbnail-user-wrapper').length
    }

    var userGeneratedSwiper = new Swiper(`.user-generated-content[data-stand-in="false"] .user-generated-content__gallery-outer-container`, params);
};

    const originalSliderToggle = function(originalSwiper, override){
        let lightBoxNewStatus = originalSwiper.getAttribute('data-lightbox-visible') == "true" ? false : true;
        let fixQuality = originalSwiper.getAttribute('data-lightbox-visible') == "true" ? "unfix" : "fix"
        
        if(override){
            lightBoxNewStatus = false
            fixQuality = "unfix"
        }

        originalSwiper.setAttribute('data-lightbox-visible', `${lightBoxNewStatus}`);

        if(lightBoxNewStatus == true){
          window.Branch.functions.fixBody(fixQuality);
          originalSwiper.style.display = 'block';
          originalSwiper.setAttribute('data-transitioning', true);
          setTimeout(function(){
            originalSwiper.style.opacity = 1;
            setTimeout(function(){
              originalSwiper.setAttribute('data-transitioning', false);
            }, 190)
          }, 10)
        } else {
          originalSwiper.setAttribute('data-transitioning', true);
            originalSwiper.style.opacity = 0;
          setTimeout(function(){
            window.Branch.functions.fixBody(fixQuality);
            originalSwiper.style.display = 'none';
            originalSwiper.setAttribute('data-transitioning', false);
          }, 200)
        }
    }


    const initUserGenerated = function(){
      var windowWidth = window.innerWidth

        const originalSwiper = document.querySelector('.user-generated-content[data-stand-in="false"]');
        const standInSwiper = document.querySelector('.user-generated-content[data-stand-in="true"]');

        if(originalSwiper && standInSwiper){
          initUserGeneratedSwiper();

          standInSwiper.addEventListener("click", function() { 
              originalSliderToggle(originalSwiper)
          })

          var ugcTimeOutFunctionId; 

          window.addEventListener("resize", function() { 
            clearTimeout(ugcTimeOutFunctionId); 
            ugcTimeOutFunctionId = setTimeout(function(){
              if (window.innerWidth != windowWidth) {
                windowWidth = window.innerWidth
                originalSliderToggle(originalSwiper, 'false');
                shiftMobileUGC();
              }
            }, 500); 
          }); 

          const closeButton  = document.querySelector('.user-generated-content[data-stand-in="false"] .user-generated-content__close-button');

          closeButton.addEventListener('click', function() {
            if(window.Branch.functions.returnWindowWidth() >= 900){
              originalSliderToggle(originalSwiper, 'false')
            }
          })

          originalSwiper.addEventListener('click', function(event) {
            if(window.Branch.functions.returnWindowWidth() >= 900){
              let clickedOutside = false;
              if(
                event.target.classList.contains('user-generated-content__gallery-outer-container') == false 
                && event.target.closest('.user-generated-content__gallery-outer-container') == null
                && event.target.classList.contains('user-generated-content__nav-left') == false 
                && event.target.closest('.user-generated-content__nav-left') == null
                && event.target.classList.contains('user-generated-content__nav-right') == false 
                && event.target.closest('.user-generated-content__nav-right') == null
            ){
                clickedOutside = true;
              }

            if(clickedOutside == true){
              originalSliderToggle(originalSwiper, 'false')
            }
          }
        })
      }
    }

    window.addEventListener("load", function(){
      initUserGenerated();
      shiftMobileUGC();
    });

